import { FC } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { GroupWrap } from 'src/components/group-wrap';
import { ActiveSection } from 'src/components/layout/header/types';
import { ExternalLink, Link } from 'src/components/navigation/link';
import { useBreakpoints } from 'src/hooks/use-breakpoints';
import {
  EnhancedAuthenticatedMonolithUser,
  useOptionalAuthenticatedMonolithUser,
} from 'src/hooks/use-monolith-user';
import { isLng } from 'src/utils/is-lng';

const angularRoutes = ['#/lng'];

export const isLngActive = (
  pathname: string,
  hash: string,
  auth: EnhancedAuthenticatedMonolithUser | null
) =>
  // for LNG Operators some paths live in the LNG section
  (auth?.isSso &&
    isLng(auth) &&
    Boolean(
      matchPath(pathname, { path: '/shippers' }) ||
        matchPath(pathname, { path: '/dashboard' })
    )) ||
  (pathname.startsWith('/platform') &&
    angularRoutes.some((angularRoute) => hash.startsWith(angularRoute)));

export const SecondaryNavLng: FC<{ activeSection: ActiveSection }> = ({
  activeSection,
}) => {
  const { hash, pathname } = useLocation();
  const monolithUser = useOptionalAuthenticatedMonolithUser();
  const { minTablet } = useBreakpoints();

  if (!activeSection.lng) return null;

  return (
    <GroupWrap
      gap={2}
      data-testid="secondary-nav"
      alignItems={!minTablet ? 'stretch' : 'center'}
      flexDirection={!minTablet ? 'column' : 'row'}
    >
      {monolithUser?.isShipper && (
        <>
          <ExternalLink
            mode="secondary"
            href={`${PRISMA_CONFIG.oldFrontendUrl}/#/lng/offers`}
          >
            Auctions
          </ExternalLink>

          {/* <ExternalLink
            mode="secondary"
            href={`${PRISMA_CONFIG.oldFrontendUrl}/#/lng/booking`}
          >
            FCFS Booking
          </ExternalLink> */}
        </>
      )}

      {monolithUser?.isSso && (
        <>
          <ExternalLink
            mode="secondary"
            href={`${PRISMA_CONFIG.oldFrontendUrl}/#/lng/offers`}
            isActive={
              hash.startsWith('#/lng/offers') &&
              !hash.startsWith('#/lng/offers/create')
            }
          >
            Manage Offer
          </ExternalLink>

          <ExternalLink
            mode="secondary"
            href={`${PRISMA_CONFIG.oldFrontendUrl}/#/lng/offers/create`}
          >
            Create Offer
          </ExternalLink>

          <Link
            mode="secondary"
            to="/shippers"
            isActive={
              pathname.startsWith('/shippers') ||
              pathname.startsWith('/dashboard/shippers')
            }
          >
            Shippers
          </Link>

          <ExternalLink
            mode="secondary"
            href={`${PRISMA_CONFIG.oldFrontendUrl}/#/lng/locations`}
          >
            Locations
          </ExternalLink>
        </>
      )}
    </GroupWrap>
  );
};
